import { Box, Card, CardActions, CardContent, CardHeader, Grid, Paper, Skeleton, Typography } from "@mui/material";
import { config, styles } from "../../style";

// proposals
const proposalsSkeleton = (
    <Box
        marginTop={"1rem"}
        overflow={"auto"}
        minHeight={"310px"}
        maxHeight={"310px"}
        sx={{
            overflowY: "scroll",
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE/Edge
            "&::-webkit-scrollbar": {
                display: "none", // Chrome/Safari
            },
        }}>
        {Array.from({ length: 2 }).map((_, index) => {
            return (
                <Card
                    key={index}
                    sx={{
                        marginBottom: "1rem",

                        borderRadius: "10px",
                        border: "1px solid #E4E4E7",
                        background: "#FFF",
                    }}
                >
                    <CardHeader
                        title={
                            <>
                                <Skeleton variant="text" sx={{ fontSize: "1rem", width: "80%", backgroundColor: "rgb(233 235 240)" }} />
                            </>
                        }
                        sx={{
                            background: styles.card.cardHeaderColor,
                            padding: ".5rem 1rem",
                            color: "#fff",
                        }}
                    ></CardHeader>

                    <CardContent sx={{ padding: "1rem" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box>
                                    <Skeleton variant="circular" width={20} height={20} />
                                    <Skeleton variant="text" sx={{ fontSize: "1rem", width: "45%" }} />
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box>
                                    <Skeleton variant="circular" width={20} height={20} />

                                    <Skeleton variant="text" sx={{ fontSize: "1rem", width: "90%" }} />
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box>
                                    <Skeleton variant="circular" width={20} height={20} />

                                    <Skeleton variant="text" sx={{ fontSize: "1rem", width: "90%" }} />
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            );
        })}
    </Box>
);

// speakers and topics
const speakersSkeleton = (
    <Box display={"flex"} overflow={"auto"}>
        {Array.from({ length: 3 })?.map((cItem, index) => (
            <Card
                key={index}
                sx={{
                    minWidth: 220,
                    borderRadius: "10px",
                    border: "1px solid #E4E4E7",
                    background: "#FFF",
                    marginRight: "1rem",
                }}>
                <Skeleton variant="rectangular" width={"100%"} height={185} />
                <CardContent>
                    <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        fontSize={"16px"}
                        fontWeight={600}
                        color={"#1A2847"}>
                        <Skeleton variant="text" width={"50%"} height={25} />
                    </Typography>
                    <Typography variant="body2" fontSize={"12px"} fontWeight={400} color={"#3F3F46"}>
                        <Skeleton variant="text" width={"100%"} height={20} />
                        <Skeleton variant="text" width={"100%"} height={20} />
                        <Skeleton variant="text" width={"80%"} height={15} />
                        <Skeleton variant="text" width={"30%"} height={15} />
                    </Typography>
                </CardContent>
            </Card>
        ))}
    </Box>
);
const newSpeakersSkeleton = (
    <Box display={"flex"} overflow={"auto"} paddingTop={"1rem"} marginTop={"-1rem"}>
        {Array.from({ length: 3 })?.map((cItem, index) => (
            <Box position={"relative"} display={"inline-block"} key={index}>
                <Typography
                    component={"div"}
                    fontSize={"10px"}
                    color={"#1A2847"}
                    fontWeight={400}
                    sx={{
                        borderRadius: "16px",
                        background: "#F4F4F5",
                        padding: "4px 10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                        position: "absolute",
                        top: "-10px",
                        left: "35px",
                        zIndex: 99,

                        width: "calc(100% - 80px)",
                    }}>
                    <Skeleton variant="text" width={"100%"} height={16} />
                </Typography>
                <Card
                    sx={{
                        minWidth: 220,
                        borderRadius: "10px",
                        border: "1px solid #E4E4E7",
                        background: "#FFF",
                        marginRight: "1rem",
                    }}>
                    <Skeleton variant="rectangular" width={"100%"} height={120} />
                    <CardContent>
                        <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            fontSize={"16px"}
                            fontWeight={600}
                            color={"#1A2847"}>
                            <Skeleton variant="text" width={"50%"} height={25} />
                        </Typography>
                        <Typography variant="body2" fontSize={"12px"} fontWeight={400} color={"#3F3F46"}>
                            <Skeleton variant="text" width={"100%"} height={15} />
                            <Skeleton variant="text" width={"100%"} height={15} />
                            <Skeleton variant="text" width={"80%"} height={15} />
                        </Typography>
                    </CardContent>
                </Card>
            </Box>
        ))}
    </Box>
);
const treadingSkeleton = (
    <Grid container spacing={2}>
        {Array.from({ length: 9 }).map((_,index) => {
            return (
                <Grid item key={index}>
                    <Typography
                        component={"p"}
                        sx={{
                            borderRadius: "10px",
                            border: "1px solid #E4E4E7",
                            background: "#FFF",
                            padding: "7px 18px 6px 16px",

                            display: "flex",
                            alignItems: "center",

                            width: "224px",
                        }}
                    >
                        <Skeleton variant="circular" width={20} height={20} />
                        <Skeleton variant="text" sx={{ fontSize: "1rem", width: "90%", marginLeft: "0.5rem" }} />
                    </Typography>
                </Grid>
            );
        })}
    </Grid>
);

// events
const recentEventsSkeleton = (
    <>
        {Array.from({ length: 2 }).map((_, index) => (
            <Card
                key={index}
                sx={
                    {
                        // marginBottom: "1rem",
                    }
                }
            >
                <CardHeader
                    title={
                        <>
                            <Skeleton variant="text" sx={{ fontSize: "1rem", width: "50%", backgroundColor: "rgb(233 235 240)" }} />
                        </>
                    }
                    sx={{
                        background: styles.card.cardHeaderColor,
                        padding: ".5rem 1rem",
                        color: "#fff",
                    }}
                ></CardHeader>

                <CardContent sx={{ padding: "1rem" }}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Box>
                                <Typography component={"div"} display={"flex"} alignItems={"center"} fontSize={"14px"} fontWeight={700} color={"#344054"}>
                                    <Skeleton variant="circular" width={40} height={40} />
                                    <Skeleton variant="text" sx={{ fontSize: "1rem", width: "150px", marginLeft: "0.5rem" }} />
                                </Typography>

                                <Box display={"flex"} flexDirection={"column"} marginTop={"1rem"}>
                                    <Skeleton variant="text" width={50} height={20} />
                                    <Skeleton variant="text" width={"50%"} height={22} />
                                </Box>
                                <Box display={"flex"} flexDirection={"column"} marginTop={"1rem"}>
                                    <Skeleton variant="text" width={50} height={20} />
                                    <Skeleton variant="text" width={"80%"} height={22} />
                                </Box>
                                <Box display={"flex"} flexDirection={"column"} marginTop={"1rem"}>
                                    <Skeleton variant="text" width={50} height={20} />
                                    <Skeleton variant="text" width={"40%"} height={22} />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box marginTop={"2rem"}>
                                <Box display={"flex"} flexDirection={"column"} marginTop={"1rem"}>
                                    <Skeleton variant="text" width={50} height={20} />
                                    <Skeleton variant="rounded" width={"100%"} height={80} sx={{ marginTop: "8px" }} />
                                </Box>
                                <Box display={"flex"} flexDirection={"column"} marginTop={"1rem"}>
                                    <Skeleton variant="text" width={50} height={20} />

                                    <Box display={"flex"} alignItems={"center"} marginTop={"0.5rem"}>
                                        <Skeleton variant="rounded" width={60} height={40} />
                                        <Skeleton variant="text" width={100} height={20} sx={{ marginLeft: "0.5rem" }} />
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        ))}
    </>
);

// agent stories
const recentStoriesSkeleton = (
    <>
        <Box sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginBottom: "1rem" }}>
            <Skeleton variant="text" sx={{ fontSize: "1rem", width: "100px" }} />
            <Skeleton variant="text" sx={{ fontSize: "1rem", width: "100px", ml: "15px" }} />
        </Box>
        <Card sx={{ maxWidth: 345, border: "unset", boxShadow: "unset", overflow: "unset" }}>
            <CardHeader
                avatar={<Skeleton variant="circular" width={40} height={40} />}
                title={<Skeleton variant="text" sx={{ fontSize: "1rem", width: "150px" }} />}
                subheader={<Skeleton variant="text" sx={{ fontSize: "1rem", width: "100px" }} />}
                sx={{
                    padding: 0,
                }}
                titleTypographyProps={{
                    sx: {
                        color: "#26272B",
                        fontSize: "16px",
                        fontWeight: 600,
                        lineHeight: "20px" /* 125% */,
                    },
                }}
                subheaderTypographyProps={{
                    sx: {
                        color: "#312E81",
                        fontSize: "12px",
                        fontWeight: 400,
                        lineHeight: "20px" /* 166.667% */,
                    },
                }}
            />
            <CardContent sx={{ padding: 0, marginTop: "1rem", height: "216px" }}>
                <Skeleton variant="text" sx={{ fontSize: "1rem", width: "150px", marginBottom: "0.5rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "100%" }} />
                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "100%" }} />
                <Skeleton variant="text" sx={{ fontSize: "0.8rem", width: "80%" }} />

                <Skeleton variant="text" sx={{ fontSize: "1rem", width: "100px", marginTop: "0.5rem" }} />
            </CardContent>
            <CardActions
                sx={{
                    borderTop: "1px solid #E4E4E7",

                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",

                    margin: "1rem -1rem -1rem",
                    padding: "0.5rem 1rem",
                }}>
                <Skeleton variant="text" sx={{ fontSize: "1.4rem", width: "40px" }} />

                <Skeleton variant="rounded" sx={{ height: "40px", width: "150px" }} />
            </CardActions>
        </Card>
    </>
);

export {
    proposalsSkeleton,
    speakersSkeleton,
    treadingSkeleton,
    newSpeakersSkeleton,
    recentEventsSkeleton,
    recentStoriesSkeleton,
};
